import './game.scss';

import gameCollection from '../gameCollection.json';
import leaderboard from '../results/leaderboard.json';
import { ResultsControls } from '../results/results.js';
import { HeaderControls } from '../header/header.js';
import { MainControls } from '../../index.js';

let headerControl = new HeaderControls;

let roundsArray = ['arcade', 'action', 'extra', 'rpg', 'strategy', 'interactive'];
// let roundsArray = ['arcade'];

let userRanks = [
  {
    'userImg': 'assets/cube.png',
    'userRankRu': 'Куб',
    'userRankEn': 'Cube'
  },
  {
    'userImg': 'assets/courier.png',
    'userRankRu': 'Курьер',
    'userRankEn': 'Courier'
  },
  {
    'userImg': 'assets/settler.png',
    'userRankRu': 'Поселенец',
    'userRankEn': 'Settler'
  },
  {
    'userImg': 'assets/mrHandy.png',
    'userRankRu': 'Мр. Помошник',
    'userRankEn': 'Mr. Handy'
  },
  {
    'userImg': 'assets/assassin.png',
    'userRankRu': 'Assassin',
    'userRankEn': 'Ассассин'
  },
  {
    'userImg': 'assets/space-marine.png',
    'userRankRu': 'Космодесантник',
    'userRankEn': 'Space Marine'
  },
  {
    'userImg': 'assets/normandy.png',
    'userRankRu': 'Нормандия N7',
    'userRankEn': 'Normandy N7'
  }
]

class GameControls {
  constructor(roundNumber, roundName, score, answer) {
    this.roundNumber = roundNumber;
    this.roundName = roundName;
    this.score = score;
    this.answer = answer;
  }

  buildGameSection(lang, theme) {
    if (this.answer === -1) {
      roundsArray = roundsArray
        .map(value => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
    }

    this.roundName = roundsArray[this.roundNumber];

    let gameSection = document.createElement('section');
    let roundsProgress = document.createElement('ul');
    let roundsProgressRound = document.createElement('li');
    let player = document.createElement('div');
    let playerButton = document.createElement('div');
    let audioProgress = document.createElement('div');
    let audioProgressTime = document.createElement('div');
    let audioProgressTimeline = document.createElement('div');
    let audioProgressTimelineProgress = document.createElement('div');
    let volumeControl = document.createElement('div');
    let volumeControlIcon = document.createElement('div');
    let volumeSlider = document.createElement('div');
    let volumeSliderRange = document.createElement('input');
    let optionsList = document.createElement('ul');
    let optionsListOption = document.createElement('li');
    let optionsListText = document.createElement('p');
    let answerText = document.createElement('p');
    let answerImg = document.createElement('div');
    let information = document.createElement('div');
    let informationImg = document.createElement('div');
    let informationName = document.createElement('div');
    let informationSong = document.createElement('div');
    let informationPlayer = document.createElement('div');
    let informationDescription = document.createElement('p');
    let gameSectionButton = document.createElement('button');
    let scoreProgressbar = document.createElement('ul');
    let scoreBar = document.createElement('li');
    let audioElement = document.createElement('audio');
    let audioElementWrongAnswer = document.createElement('audio');
    let audioElementCorrectAnswer = document.createElement('audio');

    let mainSection = document.querySelector('.main-section');

    gameSection.classList.add('game-section');
    roundsProgress.classList.add('rounds-progress');
    roundsProgressRound.classList.add('rounds-progress__round');
    player.classList.add('player');
    playerButton.classList.add('player__button');
    playerButton.classList.add('player__button_icon_pause');
    audioProgress.classList.add('audio-progress');
    audioProgressTime.classList.add('audio-progress__time');
    audioProgressTimeline.classList.add('audio-progress__timeline');
    audioProgressTimelineProgress.classList.add('timeline__progress');
    volumeControl.classList.add('volume-control');
    volumeControlIcon.classList.add('volume-control__icon');
    volumeControlIcon.classList.add('volume-control__icon_low');
    volumeSlider.classList.add('volume-slider');
    volumeSlider.classList.add('volume-slider_vertical');
    volumeSliderRange.classList.add('volume-slider__range');
    volumeSliderRange.classList.add('volume-slider__range_vertical');
    volumeSliderRange.type = 'range';
    optionsList.classList.add('options-list');
    optionsListOption.classList.add('options-list__option');
    optionsListText.classList.add('options-list__text');
    answerText.classList.add('game-section__answer-text');
    answerImg.classList.add('game-section__answer-img');
    information.classList.add('information');
    information.classList.add('information_status_description');
    informationImg.classList.add('information__img');
    informationName.classList.add('information__name');
    informationSong.classList.add('information__song');
    informationPlayer.classList.add('information__player');
    informationDescription.classList.add('information__description');
    gameSectionButton.classList.add('game-section__button');
    scoreProgressbar.classList.add('score-progressbar');
    scoreBar.classList.add('score-progressbar__bar');
    audioElementCorrectAnswer.classList.add('correct-answer-audio');
    audioElementWrongAnswer.classList.add('wrong-answer-audio');
    audioElementCorrectAnswer.src = 'assets/correctAnswer.mp3';
    audioElementWrongAnswer.src = 'assets/wrongAnswer.mp3';

    audioElementCorrectAnswer.volume = document.querySelector('.volume-slider__range').value / 100;
    audioElementWrongAnswer.volume = document.querySelector('.volume-slider__range').value / 100;


    if (theme === 'dark') {
      gameSection.classList.add('game-section_theme-color_dark');
      roundsProgress.classList.add('rounds-progress_theme-color_dark');
      roundsProgressRound.classList.add('rounds-progress__round_theme-color_dark');
      player.classList.add('player_theme-color_dark');
      playerButton.classList.add('player__button_theme-color_dark');
      audioProgress.classList.add('audio-progress_theme-color_dark');
      volumeControl.classList.add('volume-control_theme-color_dark');
      volumeControlIcon.classList.add('volume-control__icon_theme-color_dark');
      volumeSlider.classList.add('volume-slider_theme-color_dark');
      volumeSliderRange.classList.add('volume-slider__range_theme-color_dark');
      optionsList.classList.add('options-list_theme-color_dark');
      answerText.classList.add('game-section__answer-text_theme-color_dark');
      answerImg.classList.add('game-section__answer-img_theme-color_dark');
      information.classList.add('information_theme-color_dark');
      gameSectionButton.classList.add('game-section__button_theme-color_dark');
    } else {
      gameSection.classList.add('game-section_theme-color_light');
      roundsProgress.classList.add('rounds-progress_theme-color_light');
      roundsProgressRound.classList.add('rounds-progress__round_theme-color_light');
      player.classList.add('player_theme-color_light');
      playerButton.classList.add('player__button_theme-color_light');
      audioProgress.classList.add('audio-progress_theme-color_light');
      volumeControl.classList.add('volume-control_theme-color_light');
      volumeControlIcon.classList.add('volume-control__icon_theme-color_light');
      volumeSlider.classList.add('volume-slider_theme-color_light');
      volumeSliderRange.classList.add('volume-slider__range_theme-color_light');
      optionsList.classList.add('options-list_theme-color_light');
      answerText.classList.add('game-section__answer-text_theme-color_light');
      answerImg.classList.add('game-section__answer-img_theme-color_light');
      information.classList.add('information_theme-color_light');
      gameSectionButton.classList.add('game-section__button_theme-color_light');
    }

    if (lang === 'ru') {
      roundsProgressRound.classList.add('rounds-progress__round_lang_ru');
      informationDescription.classList.add('information__description_lang_ru');
      gameSectionButton.classList.add('game-section__button_lang_ru');
    } else {
      roundsProgressRound.classList.add('rounds-progress__round_lang_en');
      informationDescription.classList.add('information__description_lang_en');
      gameSectionButton.classList.add('game-section__button_lang_en');
    }

    for (let i = 0; i < 6; i++) {
      roundsProgressRound.classList.add(`rounds-progress__round_name_${roundsArray[i]}`);
      const copyCard = roundsProgressRound.cloneNode(true);
      roundsProgress.appendChild(copyCard);
      roundsProgressRound.classList.remove(`rounds-progress__round_name_${roundsArray[i]}`);
    }

    player.appendChild(playerButton);
    player.appendChild(audioProgress);
    player.appendChild(audioElement);
    audioProgress.appendChild(audioProgressTime);
    audioProgress.appendChild(audioProgressTimeline);
    audioProgressTimeline.appendChild(audioProgressTimelineProgress);
    player.appendChild(volumeControl);
    volumeControl.appendChild(volumeControlIcon);
    volumeControl.appendChild(volumeSlider);
    volumeSlider.appendChild(volumeSliderRange);

    optionsListOption.appendChild(optionsListText);

    for (let i = 0; i < 6; i++) {
      const copyCard = optionsListOption.cloneNode(true);
      optionsList.appendChild(copyCard);
    }

    let copyCard = player.cloneNode(true);
    informationPlayer.appendChild(copyCard);

    information.appendChild(informationImg);
    information.appendChild(informationName);
    information.appendChild(informationSong);
    information.appendChild(informationPlayer);
    information.appendChild(informationDescription);

    for (let i = 0; i < 30; i++) {
      const copyCard = scoreBar.cloneNode(true);
      scoreProgressbar.appendChild(copyCard);
    }

    gameSection.appendChild(roundsProgress)
    gameSection.appendChild(optionsList)
    gameSection.appendChild(answerText)
    gameSection.appendChild(answerImg)
    gameSection.appendChild(player);
    gameSection.appendChild(information);
    gameSection.appendChild(gameSectionButton);
    gameSection.appendChild(scoreProgressbar);
    mainSection.appendChild(gameSection);
    mainSection.appendChild(audioElementCorrectAnswer);
    mainSection.appendChild(audioElementWrongAnswer);

    this.actualizeScore();

    gameSectionButton.addEventListener('click', () => {
      if (this.roundNumber === (roundsArray.length - 1)) {
        document.querySelector('.main-section').innerHTML = '';
        let resultsControl = new ResultsControls(lang, theme);
        let mainControl = new MainControls();

        let userName = document.querySelector('.user__nickname').value;
        let userAvatar = document.querySelector('.user__avatar').src;

        leaderboard.unshift({
          "name": userName,
          "score": this.score,
          "rank_en": userRanks[Math.floor(this.score / 5)].userRankEn,
          "rank_ru": userRanks[Math.floor(this.score / 5)].userRankRu,
          "rank_image": userRanks[Math.floor(this.score / 5)].userImg,
          "avatar": userAvatar,
        });

        resultsControl.buildResultsMessage(lang, theme);
        // 
        mainControl.connectNewGameButtons();
        mainControl.connectMainPageResultSectionButton();
        // 
        this.answer = -1;
        this.roundName = 0;
        this.roundNumber = 0;
        this.score = 0;
      } else {
        this.nextRound();
      }
    })
  }

  buildRound() {
    if (this.answer === -1) {
      this.chooseAnswer();
    }

    this.actualizeroundsProgress();
    this.actualizeAnswerAudio();
    this.actualizeOptionsList();
  }

  nextRound() {
    this.clearRound();
    this.roundNumber++;
    this.answer = -1;
    this.roundName = roundsArray[this.roundNumber];
    this.buildRound();
    this.createOptionsListeners();
  }

  actualizeroundsProgress() {
    let roundsProgressRoundsArray = Array.from(document.querySelectorAll('.rounds-progress__round'));
    for (let i = 0; i < this.roundNumber + 1; i++) {
      roundsProgressRoundsArray[i].classList.remove('rounds-progress__round_current');
      roundsProgressRoundsArray[i].classList.add('rounds-progress__round_done');
      roundsProgressRoundsArray[this.roundNumber].classList.add('rounds-progress__round_current');
    }
  }

  actualizeAnswerAudio() {
    document.querySelector('audio').src = gameCollection[this.roundName][this.answer].track_link;
    document.querySelector('audio').play();
    document.querySelector('audio').volume = 0.5 * document.querySelector('.volume-slider__range').value / 100;
    document.querySelector('.player__button').classList.remove('player__button_icon_play');
    document.querySelector('.player__button').classList.add('player__button_icon_pause');
    document.querySelector('.game-section__answer-text').textContent = '******';
  }

  actualizeScore() {
    let scoreBarArrays = Array.from(document.querySelectorAll('.score-progressbar__bar'));

    for (let i = 0; i < this.score; i++) {
      if (!scoreBarArrays[i].classList.contains('score-progressbar__bar_active')) {
        scoreBarArrays[i].classList.add('score-progressbar__bar_active');
      }
    }
  }

  actualizeOptionsList() {
    let optionsListArray = Array.from(document.querySelectorAll('.options-list__option'));
    optionsListArray.forEach((e, i) => {
      e.childNodes[0].textContent = gameCollection[this.roundName][i].name;
    })
  }

  chooseAnswer() {
    this.answer = Math.floor(Math.random() * gameCollection[this.roundName].length);
  }

  createOptionsListeners() {
    let optionClicked = [];
    let potentialScore = 5;

    Array.from(document.querySelectorAll('.options-list__option')).forEach((e, i) => {
      optionClicked.push(false);
      e.addEventListener('click', () => {
        if (i === this.answer) {
          if (!optionClicked[i]) {
            document.querySelector('.correct-answer-audio').play();
            e.classList.add('options-list__option_choise-type_correct');
            document.querySelector('.game-section__answer-text').textContent = gameCollection[this.roundName][this.answer].name;
            document.querySelector('.game-section__answer-img').style.backgroundImage = `url("${gameCollection[this.roundName][this.answer].image}")`;
            this.score += potentialScore;
            this.actualizeScore();
            document.querySelector('.game-section__button').classList.add('game-section__button_status_active');
            document.querySelector('.player__button').classList.add('player__button_icon_play');
            document.querySelector('.player__button').classList.remove('player__button_icon_pause');
            document.querySelector('audio').pause();
            this.answer = false;
          }
        } else if (this.answer !== false) {
          if (!optionClicked[i]) {
            document.querySelector('.wrong-answer-audio').play();
            e.classList.add('options-list__option_choise-type_incorrect');
            potentialScore--;
          }
        }
        optionClicked[i] = true;
        document.querySelector('.information').classList.remove('information_status_description');
        document.querySelector('.information__img').style.backgroundImage = `url("${gameCollection[this.roundName][i].image}")`;
        document.querySelector('.information__name').textContent = gameCollection[this.roundName][i].name;
        document.querySelector('.information__song').textContent = gameCollection[this.roundName][i].track_name;
        document.querySelector('.information audio').src = gameCollection[this.roundName][i].track_link;
        document.querySelector('.information .player__button').classList.add('player__button_icon_play');
        document.querySelector('.information .player__button').classList.remove('player__button_icon_pause');

        if (document.querySelector('.main').classList.contains('main_lang_ru')) {
          document.querySelector('.information__description').textContent = gameCollection[this.roundName][i].description_ru;
        } else {
          document.querySelector('.information__description').textContent = gameCollection[this.roundName][i].description_en;
        }
      })
    })
  }

  clearRound() {
    document.querySelector('.game-section__button').classList.remove('game-section__button_status_active');
    document.querySelector('.game-section__answer-img').style.backgroundImage = `url("assets/night.jpg")`;

    Array.from(document.querySelectorAll('.options-list__option')).forEach((e) => {
      e.classList.remove('options-list__option_choise-type_incorrect');
      e.classList.remove('options-list__option_choise-type_correct');
    })
  }

}

export { GameControls };